export default __webpack_public_path__ + "static/media/faq-product-table1.8377d976.webp";